/* ============================================================================
 * GENERATED FILE — aligned with FM-0013 KERNEL (Raisy seed-round model).
 *
 * Source of truth: financial_modelling/dashboard-preview/src/app/fm0013/raisyModel.ts
 * Inputs: financial_modelling/dashboard-preview/src/app/fm0013/assumptions.json
 * Regenerate: financial_modelling/scripts/gen_market_by_year.ts  (see its header)
 * Updated: 2026-10-06
 *
 * The 30 values the deck's market slide reads: 6 series × 5 years
 * (TAM/SAM/SOM × absolute + growth). One source, every deck version.
 *
 * TAM: $5.4B (2024) → $52.6B (2030) at 46.1% CAGR (MarketsandMarkets 2025, McKinsey).
 * SAM: 40,000 founders raising annually × ~$1.8k/yr = $72M in 2026 — then one cohort accumulates per year,
 *      because a cohort stays addressable (one account runs round after round) → $360M by 2030 (49.5% CAGR).
 * SOM: base-case bottom-up ARR from the FM-0013 signup/conversion/churn build.
 * ========================================================================== */
export const MARKET_YEARS: number[] = [2026, 2027, 2028, 2029, 2030];

/** Absolute values, USD. */
export const MARKET_TAM: number[] = [11532525438.934004, 16853486286.225767, 24629470925.862957, 35993196172.33778, 52600000000];
export const MARKET_SAM: number[] = [72000000, 144000000, 216000000, 288000000, 360000000];
export const MARKET_SOM: number[] = [145242.2664, 1067991.6089000476, 2527710.630733215, 4734574.280759221, 7927679.968433247];

/** Growth per year (decimal). `null` = no prior year to compare against (2026). */
export const MARKET_TAM_GROWTH: (number | null)[] = [0.4613873063161089, 0.46138730631610914, 0.4613873063161089, 0.4613873063161087, 0.46138730631610914];
export const MARKET_SAM_GROWTH: (number | null)[] = [null, 1, 0.5, 0.33333333333333326, 0.25];
export const MARKET_SOM_GROWTH: (number | null)[] = [null, 6.353173668873895, 1.3667888489653675, 0.8730681523406261, 0.674422978355298];

/** Supporting: SOM as a share of SAM, and the paying-customer build behind SOM. */
export const MARKET_SOM_PCT_OF_SAM: number[] = [0.0020172537, 0.00741660839513922, 0.01170236403117229, 0.016439494030413962, 0.02202133324564791];
export const MARKET_CUSTOMERS: number[] = [224, 1319, 2497, 3741, 5011];

/** Span CAGR 2026 → 2030, endpoint to endpoint.
 *  The deck prints these instead of recomputing growth in prose — three copies of the
 *  word "flat" shipped in the slides while SAM was compounding at 49.5%/yr. */
export const MARKET_CAGR: { tam: number; sam: number; som: number } = {
  tam: 0.4613873063161089,
  sam: 0.4953487812212205,
  som: 1.7180864977084975,
};

/** SAM's basis, in the model's own units — so no slide hardcodes "40,000" or "$1,800". */
export const MARKET_SAM_BASIS: {
  companiesPerYear: number;
  spendPerCompany: number;
  baseYear: number;
} = {
  companiesPerYear: 40000,
  spendPerCompany: 1800,
  baseYear: 2026,
};
